import React, { useEffect, useState } from 'react';
import { connect } from 'umi';
import { Radio } from 'antd';
import InfiniteScroll from 'react-infinite-scroll-component';
import cl from 'classnames';
import { get, isEmpty, flattenDeep } from 'lodash';
import { BaseSpin } from '@/components';
// import { trackSensors } from '@/utils/appsensors';
import { getDeviceType } from '@/utils/utilsPoint';
import useResponsive from '@/hooks/useResponsive';
import useGCPI18n from '@/hooks/useGCPI18n';
import { DataOffers } from '../components';
import Header from '../Header';

// import filter from '@/assets/img/point/filter@2x.png';
// import aceSort from '@/assets/img/point/aceSort@2x.png';
// import descSort from '../../../assets/img/point/descSort@2x.png';

import styles from './index.less';

const DEFAULT_PAGE_SIZE = 10;

const ShopList = props => {
  // 响应式 hook
  useResponsive();

  // const catgct = isEmpty(get(props, 'location.query'))
  //   ? get(props, 'location.state.catgct')
  //   : get(props, 'location.query');

  const { getCatgctList, getProductSearch, loading = false } = props;
  // const [userTag, setTag] = useState(''); // 区分普通用户、FWA 预付费和后付费用户
  const [currCatgInfo, setCurrCatgInfo] = useState({});
  const [catgctList, setcatgctList] = useState([]);
  const [catgctId, setcatgctId] = useState(null);
  const [pageInfo, setofferTotal] = useState([]);
  const [sortBy, setSortBy] = useState('PRICE_ASC');
  // const [priceMax, setPriceMax] = useState(null);
  const [dataOfferList, setdataOfferList] = useState([]);
  // const [isdrawer, setDrawer] = useState(false);
  // const [filterCondition, setFilterCondition] = useState({});
  const GCPI18n = useGCPI18n();

  const filretOffer = filretData => {
    getProductSearch(filretData).then(offer => {
      if (get(offer, 'pointProductList')) {
        setdataOfferList(get(offer, 'pointProductList'));
        setofferTotal(get(offer, 'pageInfo'));
      } else {
        setdataOfferList([]);
        setofferTotal([]);
      }
    });
  };

  // useEffect(() => {
  //   // 神策埋点;
  //   trackSensors('RewardCatPV', {
  //     category: get(catgct, 'name'),
  //     subcat: 'All',
  //   });
  // }, []);

  useEffect(() => {
    // 根据路由id获取当前目录的code
    const str = window.location.pathname.split('/');
    const targetStr = str[str.length - 1];
    const currCatgId = Number(targetStr);
    getCatgctList().then(data => {
      if (get(data, 'code') === '200' && get(data, 'data.prodCatgList')) {
        const initCatgList = get(data, 'data.prodCatgList') || [];
        const currCatgList = initCatgList.filter(item => item.id === currCatgId);
        // 获取当前目录信息
        setcatgctId(currCatgId);
        if (currCatgList && currCatgList.length > 0) {
          setCurrCatgInfo(currCatgList[0]);
          getCatgctList({
            parentCatgCode: get(currCatgList, '[0].code'),
          }).then(catgctListres => {
            if (get(catgctListres, 'code') === '200' && get(catgctListres, 'data.prodCatgList')) {
              const prodCatgList = get(catgctListres, 'data.prodCatgList');
              setcatgctList(prodCatgList);
            }
          });
          filretOffer({
            catgIds: currCatgId,
            pageInfo: {
              currentPage: 1,
              pageSize: DEFAULT_PAGE_SIZE,
            },
          });
        }
      }
    });
  }, []);

  // 监听页面的滚动
  window.onscroll = () => {
    // scrollTop是滚动条滚动时，距离顶部的距离
    // 为了保证兼容性，这里取两个值，哪个有值取哪一个
    const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
    // windowHeight是可视区的高度
    const windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
    // scrollHeight是滚动条的总高度
    const scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
    // 滚动条到底部的条件
    if (scrollTop + windowHeight === scrollHeight) {
      if (get(pageInfo, 'total') > get(pageInfo, 'pageSize')) {
        getProductSearch({
          catgIds: Number(get(currCatgInfo, 'id')),
          // tag: userTag,
          pageInfo: {
            currentPage: Number(get(pageInfo, 'currentPage')) + 1,
            pageSize: DEFAULT_PAGE_SIZE,
          },
        }).then(offer => {
          if (get(offer, 'pointProductList')) {
            setdataOfferList(dataOfferLists => {
              dataOfferLists.push(get(offer, 'pointProductList'));
              return flattenDeep(dataOfferLists);
            });
            setofferTotal(get(offer, 'pageInfo'));
          }
        });
      }
    }
  };

  const selectCatgct = e => {
    // 神策埋点;
    // trackSensors('RewardCatPV', {
    //   category: get(catgct, 'name'),
    //   subcat: e.target.id,
    // });
    if (!loading) {
      setcatgctId(e.target.value);
      // 重置条件
      setSortBy('PRICE_ASC');
      const params = {
        sortBy: 'PRICE_ASC',
        catgIds: e.target.value,
        // tag: userTag,
        pageInfo: {
          currentPage: 1,
          pageSize: DEFAULT_PAGE_SIZE,
        },
      };
      filretOffer(params);
      // setFilterCondition(params);
    }
  };

  const loadMoreData = async () => {
    await getProductSearch({
      catgIds: catgctId,
      // tag: userTag,
      // priceMax,
      sortBy,
      pageInfo: {
        currentPage: Number(get(pageInfo, 'currentPage')) + 1,
        pageSize: DEFAULT_PAGE_SIZE,
      },
    }).then(offer => {
      if (get(offer, 'pointProductList')) {
        setdataOfferList(dataOfferLists => {
          let temp = dataOfferLists;
          const list = get(offer, 'pointProductList');
          temp = [...temp, ...list];
          return flattenDeep(temp);
        });
        setofferTotal(get(offer, 'pageInfo'));
      }
    });
  };

  return (
    <div
      className={cl(styles.shoplist, { [styles.androidShoplist]: getDeviceType() === 'android' })}
    >
      <Header
        title={get(currCatgInfo, 'name')}
        notNewPage
        // searchText={GCPI18n({
        //   id: 'HEADER_SEARCH_TEXT',
        // })}
        // openSearch={openSearch}
      />

      <div className={cl(styles.groupButton, { [styles.emptyGroupButton]: isEmpty(catgctList) })}>
        <BaseSpin spinning={loading}>
          {!isEmpty(catgctList) && (
            <Radio.Group
              defaultValue={Number(get(currCatgInfo, 'id'))}
              value={catgctId}
              buttonStyle="solid"
              onChange={selectCatgct}
            >
              <Radio.Button value={Number(get(currCatgInfo, 'id'))} id="All">
                {GCPI18n({
                  id: 'lb_dito_shop_list_page_all',
                })}
              </Radio.Button>
              {catgctList.map(catgctItem => (
                <Radio.Button value={get(catgctItem, 'id')} id={get(catgctItem, 'name')}>
                  {get(catgctItem, 'name')}
                </Radio.Button>
              ))}
            </Radio.Group>
          )}
        </BaseSpin>
      </div>
      {/* {!!get(pageInfo, 'total') && (
        <div className={styles.filret} style={isEmpty(catgctList) ? { marginTop: '0.2rem' } : null}>
          <p className={styles.pageSize}>
            {get(pageInfo, 'total')}{' '}
            {GCPI18n({
              id: 'DITO_SHOP_LIST_PAGE_REWARDS',
            })}
          </p>
          <div className={styles.searchFilret}>
            <img
              onClick={onOPenDrawer}
              className={styles.sort}
              src={sortBy === 'PRICE_ASC' ? aceSort : descSort}
              alt=""
            />
            <span className={styles.pointslow}>
              {sortBy === 'PRICE_ASC'
                ? GCPI18n({
                  id: 'DITO_SHOP_LIST_PAGE_POINTS_LOW_TO_HIGH',
                })
                : GCPI18n({
                  id: 'DITO_SHOP_LIST_PAGE_POINTS_HIGH_TO_LOW',
                })}
            </span>
            <img onClick={onOPenDrawer} className={styles.filter} src={filter} alt="" />
          </div>
        </div>
      )} */}
      <div id="scrollableDiv" className={styles.dataOffersWrap}>
        <InfiniteScroll
          dataLength={dataOfferList.length}
          next={loadMoreData}
          hasMore={dataOfferList.length < get(pageInfo, 'total')}
          scrollableTarget="scrollableDiv"
        >
          <DataOffers
            dataOfferList={dataOfferList}
            catgctList={catgctList}
            entrancePage="DITO Offer"
          />
        </InfiniteScroll>
      </div>

      {/* <SearchDrawer
        isdrawer={isdrawer}
        closeDrawer={onCloseDrawer}
        onFilretOffer={onFilretOffer}
        defaultFilter={filterCondition}
      /> */}
    </div>
  );
};

const mapDispatchToProps = dispatch => ({
  // 获取商品列表目录
  getCatgctList: payload =>
    dispatch({
      type: 'pointShop/getCatgctList',
      payload,
    }),

  // 获取商品列表
  getProductSearch: payload =>
    dispatch({
      type: 'pointShop/getProductSearch',
      payload,
    }),
});

export default connect(
  ({ pointShop, loading }) => ({
    pointDetail: pointShop.pointDetail,
    faqList: pointShop.faqList,
    loading: loading.effects['pointShop/getProductSearch'],
  }),
  mapDispatchToProps,
)(ShopList);
